import { useNavigate, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import NdcxImportCard from '../../components/Import-NDC/NdcxImportCard';
import BackButton from '../../components/RebookFlight/BackButton';
import { keycloak } from '../../keycloak';

const NdcxImportPage = () => {
  const navigate = useNavigate();
  const isItAdmin = keycloak.hasRealmRole('Role_IT_Administrator');
  const isBusinessAdmin = keycloak.hasRealmRole('Role_Business_Administrator');
  const canAccessImport = isItAdmin || isBusinessAdmin;

  if (!canAccessImport) {
    return <Navigate to="/tff/common/error-403" />;
  }

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Box sx={{ padding: 3 }}>
      <BackButton handleClick={handleBack} />
      <NdcxImportCard setViewDialog={() => navigate(-1)} />
    </Box>
  );
};

export default NdcxImportPage;
